module.exports = __webpack_public_path__ + "static/predictivepoem 25-01-541d3e9ef717d800aa314e87cedd8d66.jpg";